import React, { useState, useMemo, useEffect } from 'react';
import { multiplePanel as Panel } from '@zero/multiple-caseader';
import './index.less';
// import { Empty, Input } from 'antd';
import SelectedPanel from './resultPanel';
import { cloneDeep } from 'lodash';
import { Checkbox } from '@drip/drip-design';

export default function OrganizationSelector({
  onChange,
  options = [],
  value = [],
  fieldNames = { label: 'label', value: 'value', children: 'children' },
  useExtraOperate = null,
  disabled = false,
  showSearch = false,
  showResultPanel = true,
  showSelectAll = false,
  ...props
}) {
  const selectPanel = Object.assign(
    {
      panelNameList: ['一级部门', '二级部门', '三级部门'],
      searchPlaceholder: '请搜索一级部门',
    },
    props.selectPanel
  );
  const resultPanel = Object.assign(
    {
      panelPlaceholder: '暂无部门，请先在左侧选择部门！',
      searchPlaceholder: '请搜索已添加部门',
      subtitle: '已添加部门',
    },
    props.resultPanel
  );
  const [panelcontent, setpanelcontent] = useState([]);

  useEffect(() => {
    // 展示面板的值
    const fatherArr = [];
    value.map((ele) => {
      fatherArr.push(findFather(options, ele, fieldNames));
    });
    setpanelcontent(fatherArr.reverse());
  }, [value, options, fieldNames]);

  const optionsTree = useMemo(() => AddParentName(options, '', fieldNames), [options, fieldNames]);
  const allKeys = useMemo(() => getAllKeys(options, [], fieldNames), [options, fieldNames]);

  // 选择器中的值发生变化后直接同步到右边展示面板上
  const onSelectChange = (val, extraInfo) => {
    // 要判断一下长度，添加和删除的情况要分开
    if (val.length > panelcontent.length) {
      if (useExtraOperate?.beforeAdd) {
        useExtraOperate.beforeAdd().then(() => {
          change();
        });
      } else {
        change();
      }
    } else {
      if (useExtraOperate?.beforeDelet) {
        useExtraOperate.beforeDelet().then(() => {
          change();
        });
      } else {
        change();
      }
    }

    function change() {
      // const selectedContent = [];
      // extraInfo.map((item) => {
      //   selectedContent.push({
      //     parentValue: item.allParentValueIndex.replace(/-/g, '/'),
      //     parentName: item.allParentName.replace(/-/g, '/'),
      //   });
      // });
      // setpanelcontent(selectedContent.reverse()); //同步右边的展示面板
      onChange(val); // 同步外部的value
    }
  };

  // 删除操作
  function deletItems(val) {
    // 同步选择选择器面板的值
    const ids = val.map((item) => item.split('#').pop());
    onChange(value.filter((item) => ids.indexOf(item) === -1));
    // setpanelcontent((panelcontent) => panelcontent.filter((item) => val.indexOf(item.parentValue) === -1));
  }

  // 筛选一级部门
  function filter(inputValue, path) {
    return path.filter((option) => option.name.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
  }

  // 全选操作
  function handelSelectAll(e) {
    if (e.target.checked) {
      onChange(allKeys);
    } else {
      onChange([]);
    }
  }

  return (
    <div className="multiple-select-panel-acore">
      {showSelectAll && (
        <div className="multiple-select-panel-select-all">
          <Checkbox
            indeterminate={value.length < allKeys.length && value.length > 0}
            checked={value.length === allKeys.length && value.length > 0}
            onChange={handelSelectAll}
            disabled={disabled}
          >
            全选
          </Checkbox>
        </div>
      )}
      <div className="multiple-select-panel">
        <div className="selector">
          <div className="selector-title">
            <span className="item">{selectPanel.panelNameList[0]}</span>
            <span className="item">{selectPanel.panelNameList[1]}</span>
            <span className="item">{selectPanel.panelNameList[2]}</span>
          </div>
          <Panel
            options={optionsTree}
            fieldNames={fieldNames}
            value={value}
            showSearch={showSearch && { filter }}
            onChange={(val, a) => {
              onSelectChange(val, a.selectValTreeNode);
            }}
            disabled={disabled}
            placeholder={selectPanel.searchPlaceholder}
          />
        </div>
        {showResultPanel && (
          <SelectedPanel
            disabled={disabled}
            selectValTreeNode={panelcontent}
            deletItem={deletItems}
            beforeDelet={useExtraOperate?.beforeDelet}
            {...resultPanel}
          />
        )}
      </div>
    </div>
  );
}

// 将选择器上的修改merge到展示面板上，新增的条目出现在列表首部
export function mergeSelectedContent({ selectedContent = [], panelcontent = [] }) {
  if (!selectedContent || !selectedContent.length) return [];
  if (selectedContent.length === panelcontent.length) return panelcontent;
  const short = cloneDeep(selectedContent.length > panelcontent.length ? panelcontent : selectedContent);
  let long = cloneDeep(selectedContent.length > panelcontent.length ? selectedContent : panelcontent);

  // 找不同
  short.map((ele) => {
    long = long.filter((o) => o.parentValue !== ele.parentValue);
  });
  const diffArr = long;
  // 根据长短
  if (selectedContent.length > panelcontent.length) {
    return diffArr.concat(panelcontent);
  } else {
    diffArr.map((ele) => {
      panelcontent = panelcontent.filter((a) => a.parentValue !== ele.parentValue);
    });
    return panelcontent;
  }
}

// 根据子节点value，找到其所有父节点的属性
export function findFather(tree, childVal, fieldNames) {
  const value = [];
  const name = [];
  let ifget = false;
  mapTree(tree, childVal, fieldNames);

  function mapTree(tree, childVal, fieldNames) {
    for (let i = 0; i < tree.length; i++) {
      value.push(tree[i][fieldNames.value]);
      name.push(tree[i][fieldNames.label]);
      if (tree[i][fieldNames.value] === childVal) {
        ifget = true;
        return;
      } else if (tree[i].children && tree[i].children.length > 0) {
        mapTree(tree[i].children, childVal, fieldNames);
        if (ifget) break;
      } else {
        value.pop();
        name.pop();
        continue;
      }
    }
    if (!ifget) {
      value.pop();
      name.pop();
    }
  }

  return {
    parentValue: value.join('#'),
    parentName: name.join('/'),
  };
}

function selectedDisabled(organizations, list) {
  list.map((item) => {
    const codes = item.parentValue.split('/');
    organizations = mapTree(organizations, codes, 0);
  });
  function mapTree(tree, codes, index) {
    for (let i = 0; i < tree.length; i++) {
      if (tree[i].value === codes[index]) {
        tree[i].disabled = true;
        if (tree[i].children && codes[index + 1]) {
          tree[i].children = mapTree(tree[i].children, codes, index + 1);
        }
        break;
      }
    }
    return tree;
  }
  return cloneDeep(organizations);
}

function selectedAvailable(organizations, list) {
  list.map((item) => {
    const codes = item.parentValue.split('/');
    organizations = mapTree(organizations, codes, 0)[0];
  });
  function mapTree(tree, codes, index) {
    let isChildAllAvailable = true;
    for (let i = 0; i < tree.length; i++) {
      if (tree[i].value === codes[index]) {
        if (tree[i].children && codes[index + 1]) {
          const result = mapTree(tree[i].children, codes, index + 1);
          tree[i].children = result[0];
          tree[i].disabled = !result[1];
        } else {
          tree[i].disabled = false;
        }
      }
      if (tree[i].disabled) isChildAllAvailable = false;
    }
    return [tree, isChildAllAvailable];
  }
  return cloneDeep(organizations);
}

// 遍历部门树，给节点添加parentName
function AddParentName(tree, parentName, fieldNames) {
  if (Array.isArray(tree)) {
    tree.forEach((item) => {
      item.parentName = parentName || '';
      item.allParentName = `${parentName ? parentName + '-' : ''}${item[fieldNames.label]}`;
      if (item.children && item.children.length) {
        item.children = AddParentName(item.children, item.allParentName, fieldNames);
      }
    });
  }
  return tree;
}

// 获取所有子节点

function getAllKeys(arr, keys = [], fieldNames) {
  arr.forEach((item) => {
    if (item.children && item.children.length) {
      getAllKeys(item.children, keys, fieldNames);
    } else {
      keys.push(item[fieldNames.value]);
    }
  });
  return keys;
}
